import { find } from 'lodash';
import React from 'react';
import styled from 'styled-components';

/** 只读表单用,下拉 */
export default function TextSelect({ value, options = [], empty = '' }) {
  return <Root>{find(options, { value })?.label || empty}</Root>;
}

const Root = styled.div`
  padding: 4px var(--td-comp-paddingLR-s);
`;
